'use client';

import { useEffect, useState } from 'react';

import { Button } from '@/shared';
import { useCookie } from '@/shared/hooks';

export function ResendCode({
	loading,
	onClick,
}: {
	loading: boolean;
	onClick: (payload: Record<string, any>) => void;
}) {
	const [expiresAt] = useCookie<number | null>('resend_code_at', null);
	const [remaining, setRemaining] = useState<number>(0);

	useEffect(() => {
		const interval = setInterval(() => {
			if (!expiresAt) {
				return;
			}

			const now = new Date();
			const remaining = expiresAt - now.getTime();

			if (remaining <= 0) {
				setRemaining(0);
				return;
			}

			setRemaining(Math.ceil(remaining / 1000));
		}, 1000);

		return () => {
			clearInterval(interval);
		};
	}, [expiresAt]);

	return (
		<Button
			type="button"
			disabled={!!remaining || loading}
			variant="plain-gray"
			size="xs"
			className="font-normal"
			onClick={onClick}
		>
			{loading
				? 'Отправка'
				: remaining
					? `Новый код можно получить через ${remaining} сек`
					: 'Получить новый код'}
		</Button>
	);
}
